export default from './ModalContainer';



// WEBPACK FOOTER //
// ./src/components/molecules/ModalContainer/index.js